import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signSickLeaveDocumentWithTelematikInfrastructureInput,
  useDeSignSickLeaveWithTelematikInfrastructureMutation as useDeSignSickLeaveWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeSignSickLeaveWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignSickLeaveWithTelematikInfrastructureMutation(
    $input: De_signSickLeaveDocumentWithTelematikInfrastructureInput!
  ) {
    de_signSickLeaveDocumentWithTelematikInfrastructure(input: $input) {
      de_SickLeave {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...deSickLeaveFragment
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignSickLeaveWithTelematikInfrastructureMutationType>, "variables"> & {
  id: De_signSickLeaveDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignSickLeaveWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignSickLeaveWithTelematikInfrastructureMutationType>(
    mutation,
    TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignSickLeaveWithTelematikInfrastructureMutation }
